<template lang="pug">
  .component-create-reporting
    .row.columns
      .row
        fieldset.large-2.columns
          label Status
          select(v-model="body.status")
            option(value="PENDING_REVIEW") Pending Review
            option(value="CONFIRMED") Confirmed
            option(value="RESOLVED") Resolved
            option(value="VOIDED") Voided
        fieldset.large-3.columns
          label Type
          select(v-model="body.reporting_type_id", v-on:change="isDamageReport")
            option(v-for="type in reportingTypes", :value="type.id") {{type.name}}
        fieldset.large-3.columns
          label Vehicle
          selectize-vehicle(disabled, :selectedValue="item.vehicle.id", :max-items="1", @optionSelected="vehicleSelected")

        fieldset.large-3.columns
          label Driver
          selectize-driver(disabled, @optionSelected="driverSelected", :selectedValue="item.driver ? item.driver.id: null", :max-items="1")
      .row.columns
        label Description
          textarea(v-model="body.description", rows="8")
      .row.columns
        label(aria-describedby='documentsUpload')
          dropzone#myVueDropzone(:url='dropzoneUrl', @vdropzone-success='uploaded')
      .row.columns(v-if="damageReport")
        vehicle-damage(v-if="body.damage_position_raw", :vehicleType="item.vehicle.category.vehicle_type.name",  :items="body.damage_position_raw", :editable="true", @damagesUpdated="updateDamages", :vehicleDamagePicture="item.vehicle.category.damage_picture_external" )
      .row
        .columns.text-center
          label
            input.button.expanded(type='submit', v-on:click="submit")

</template>
<script type="text/babel">
  import Dropzone from 'components/structure/Dropzone'
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import VehicleDamage from '../../components/backoffice/VehicleDamage.vue'
  import SelectizeVehicle from '../../components/structure/ui/lists/selectize/SelectizeVehicle'
  import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'

  export default {
    name: 'BackofficeEditReporting',
    components: {
      SelectizeDriver,
      SelectizeVehicle,
      VehicleDamage,
      Dropzone
    },
    data() {
      return {
        reportingTypes: [],
        pins: [],
        showVehicleSelect: null,
        body: {
          damage_position_raw: [],
          reporting_type_id: null,
          vehicle_id: null,
          status: null,
          description: null,
          attachments: []
        },
        vehicle: null,
        damageReport: false,
        dropzoneUrl: KeplerBackofficeSdk.getUrlForDropzone()

      }
    },
    created() {
      this.body.damage_position_raw = this.item.damage_position_raw ? this.item.damage_position_raw : []
      this.body.status = this.item.status
      this.body.reporting_type_id = this.item.type.id
      this.body.description = this.item.description
      this.body.vehicle_id = this.item.vehicle.id

      this.vehicle = this.item.vehicle

      this.body.reporting_type_id = this.item.type.id
      if (this.item.driver) {
        this.body.driver_id = this.item.driver.id
      }
      this.isDamageReport()

      this.body.vehicle_id = this.item.vehicle.id


      KeplerBackofficeSdk.selects.reportingTypes((data) => {
        this.reportingTypes = data
      })
    },
    methods: {
      updateDamages(pins) {
        this.body.damage_position_raw = pins
      },
      driverSelected(driver) {
        this.body.driver_id = driver.id
      },
      vehicleSelected(vehicle) {
        this.body.vehicle_id = vehicle.id
        this.vehicle = vehicle
        KeplerBackofficeSdk.vehicles.select(vehicle.id).get((data) => {
          this.item.vehicle.category = data.category
        })
      },
      isDamageReport() {
        var damageReportId = 3
        this.damageReport = this.body.reporting_type_id === damageReportId
      },
      uploaded: function (file, response) {
        this.body.attachments.push(response.token)
      },
      submit() {
        if (this.item) {
          if (this.body.driver_id == '') {
            this.body.driver_id = null
          }

          KeplerBackofficeSdk.reportings.select(this.$route.params.id).edit(this.body, (data) => {
            this.$router.push({name: 'reporting', params: {id: data.id}})
          })
        } else {
          KeplerBackofficeSdk.reportings.make(this.body.vehicle_id, this.body, (data) => {
            this.$router.push({name: 'reporting', params: {id: data.id}})
          })
        }

      }
    },
    computed: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// EditReporting.vue?05daf86e